import superjson from 'superjson';

export const trpcTransformer = superjson;
